<template>
  <v-ons-page id="mainPage" :style="swipePosition">
    <v-ons-toolbar class="home-toolbar">
      <div class="left"><a @click="goReboot" style="margin-left: 10px;"><img src="../assets/lasmeru-logo-bold.png" width="100" height="35"></a></div>
      <div class="center" style="text-align: center;">{{title}}</div>
      <div class="right">
        <v-ons-toolbar-button @click="$store.commit('splitter/toggle')">
          <span v-if="sideMenuBadge"><v-ons-icon style="color: red;" icon="fa-exclamation-circle, material:md-menu"></v-ons-icon></span>
          <span v-else><v-ons-icon icon="fa-bars, material:md-menu"></v-ons-icon></span>
        </v-ons-toolbar-button>
      </div>
    </v-ons-toolbar>

    <v-ons-tabbar swipeable position="auto"
      :modifier="md ? 'autogrow white-content' : ''"
      :on-swipe="md ? onSwipe : null"
      :tabbar-style="swipeTheme"
      :tabs="tabs"
      :visible="true"
      :index.sync="index"
    >
    </v-ons-tabbar>
  </v-ons-page>
</template>

<script>
import MsgRoot from './MsgRoot'
import ScheduledRoot from './ScheduledRoot'
import AccountRoot from './AccountRoot'

// Just a linear interpolation formula
const lerp = (x0, x1, t) => parseInt((1 - t) * x0 + t * x1, 10)
// RGB colors
const red = [244, 67, 54]
// const blue = [30, 136, 229]
const purple = [103, 58, 183]

export default {
  data () {
    return {
      colors: red,
      animationOptions: {},
      topPosition: 0,
      mainTabs: [
        {
          label: 'アカウント',
          // icon: this.md ? null : 'fa-envelope',
          icon: 'fa-user-cog',
          page: AccountRoot,
          theme: purple,
          badge: ''
        },
        {
          label: 'トリガー型',
          // icon: this.md ? null : 'fa-envelope',
          icon: 'fa-envelope',
          page: MsgRoot,
          theme: purple,
          badge: ''
        },
        {
          label: '送信日指定',
          // icon: this.md ? null : 'fa-envelope',
          icon: 'fa-calendar',
          page: ScheduledRoot,
          theme: purple,
          badge: ''
        }
      ]
    }
  },

  mounted () {
    var self = this
    // Web版だと、AppViewが最終アクセス履歴に残って、ここから開始されるケースが多いので
    // ログインされていないとルートに飛ばすようにする。
    // onsenuiのライフサイクルイベントでこのコンポーネントのpageが表示される度に処理を実行
    document.addEventListener('show', function (event) {
      if (event.target.matches('#mainPage')) {
        console.log('onsenui init! show event')
        if ((self.$store.state.account.token === null) || (self.$store.state.account.token === undefined)) {
          console.log('account error!!!!: ', self.$store.state.account.token)
          self.goReboot()
        }
        if ((self.$store.state.user.prof === null) || (self.$store.state.user.prof === undefined)) {
          console.log('user error!!!!: ', self.$store.state.user.prof)
          self.goReboot()
        }
        if (self.$store.state.lic.val === null) {
          console.log('Lic error!!!!: ')
          self.goReboot()
        }
      }
    }, false)
  },

  methods: {
    onSwipe (index, animationOptions) {
      // Apply the same transition as ons-tabbar
      this.animationOptions = animationOptions

      // Interpolate colors and top position
      const a = Math.floor(index)
      const b = Math.ceil(index)
      const ratio = index % 1
      this.colors = this.colors.map((c, i) => lerp(this.tabs[a].theme[i], this.tabs[b].theme[i], ratio))
      this.topPosition = lerp(this.tabs[a].top || 0, this.tabs[b].top || 0, ratio)
    },

    goReboot () {
      this.$router.replace({path: '/'})
    }
  },

  computed: {
    slideDirection: {
      get () {
        // return 'slide'
        // return 'back'
        return this.$store.state.routerAnim.anim
      }
    },

    index: {
      get () {
        return this.$store.state.tabbar.index
      },
      set (newValue) {
        this.$store.commit('tabbar/set', newValue)
      }
    },
    title () {
      return this.md ? 'Miley' : this.tabs[this.index].title || this.tabs[this.index].label
    },
    swipeTheme () {
      return this.md && {
        backgroundColor: `rgb(${this.colors.join(',')})`,
        transition: `all ${this.animationOptions.duration || 0}s ${this.animationOptions.timing || ''}`
      }
    },
    swipePosition () {
      return this.md && {
        top: this.topPosition + 'px',
        transition: `all ${this.animationOptions.duration || 0}s ${this.animationOptions.timing || ''}`
      }
    },
    tabs: {
      get () {
        // console.log('MainTab Get*****')
        let sbuf = ''

        sbuf = this.$store.state.tabBadgeMessages.badge
        this.mainTabs[0].badge = sbuf

        return this.mainTabs
      }
    },
    sideMenuBadge: {
      get () {
        return false
      }
    }
  }
}
</script>

<style>
/* Custom 'white-content' modifier */

.page--material .toolbar--white-content__center,
.page--material .toolbar-button--white-content,
.page--material :checked + .tabbar--white-content__button {
  color: white;
}

.page--material .tabbar--white-content__button {
  color: rgba(255, 255, 255, 0.7);
}

.page--material .tabbar--white-content__border {
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/AppView.vue